/**
 * Shown when the logged-in employee lookup fails (transient DB/network error) rather than
 * returning a definitive "no matching user" result. Distinct from <NoAccess />: this is a
 * recoverable failure, so we offer a retry instead of telling the user they lack access.
 */
export function AccessError({ onRetry }: { onRetry: () => void }) {
  return (
    <main className="access-screen">
      <div className="access-screen__card">
        <div className="brand-logo" aria-hidden>
          <img src="/public/capacitor-logo.svg" alt="Capacitor Logo" />
        </div>
        <h1 className="access-screen__title">Something went wrong</h1>
        <p className="access-screen__message">
          We couldn&apos;t verify your access right now. This is usually temporary.
        </p>
        <button type="button" className="secondary-button" onClick={onRetry}>
          Try again
        </button>
      </div>
    </main>
  );
}
